import { DATE_FORMAT_DATE } from "../date-base/constants";

export const DEFAULT_CLIENT_DATE_FORMAT = DATE_FORMAT_DATE;
export const DEFAULT_DISPLAY_DATE_FORMAT = "yyyy-MM-dd";
export const DEFAULT_SERVER_DATE_FORMAT = "yyyy-MM-dd";
